import { useQuery } from "react-query";

import { ApiError } from "@api/fetch";
import { AppToaster } from "@components/AppToaster";

import { fetchRules } from "@pages/registry/api";

/*
 * Returns query result with rules from registry
 * Shows AppToaster if there is a failure to load the registry
 */
export const useRegistryRules = () => {
  return useQuery(["repos"], () => fetchRules(), {
    onError: (err: ApiError) =>
      AppToaster.show({
        message: `Failed to load the registry: ${err.body?.error}`,
        intent: "danger",
      }),
  });
};
